import React, { Component } from "react";

import FormatUtils from "../../utils/formatUtils";
import addressImg from "../../images/mailing-address.png";

class CollectionItems extends Component {
  render() {
    let lobDetails = this.props.lobDetails;

    return (
      <div>
        {this.renderLocations(lobDetails.Locations, lobDetails.GeneralInfo)}
        {this.renderVehicles(lobDetails.Vehicles, lobDetails.GeneralInfo)}
        {this.renderPersonalProperties(
          lobDetails.PersonalProperties,
          lobDetails.GeneralInfo
        )}
      </div>
    );
  }

  renderLocations(locations, generalInfo) {
    if (!locations || locations.length === 0) {
      return null;
    }

    return (
      <div>
        {this.renderCollectionHeader(
          generalInfo.IsPolicy ? "POLICY LOCATIONS" : "QUOTE LOCATIONS"
        )}
        {locations.map((location, idx) => {
          let addressDescription = this.getAddressDescription(location);

          return (
            <div key={idx}>
              {this.renderItemHeader(addressDescription)}
              {this.renderLocation(location, generalInfo.LobId)}
            </div>
          );
        })}
      </div>
    );
  }

  renderVehicles(vehicles, generalInfo) {
    if (!vehicles || vehicles.length === 0) {
      return null;
    }

    return (
      <div>
        {this.renderCollectionHeader(
          generalInfo.IsPolicy ? "POLICY VEHICLES" : "QUOTE VEHICLES"
        )}
        {vehicles.map((vehicle, idx) => {
          return (
            <div key={idx}>
              {this.renderItemHeader(
                vehicle.Year + " " + vehicle.Make + " " + vehicle.Model
              )}
              {this.renderVehicle(vehicle)}
            </div>
          );
        })}
      </div>
    );
  }

  renderPersonalProperties(personalProperties, generalInfo) {
    if (!personalProperties || personalProperties.length === 0) {
      return null;
    }

    return (
      <div>
        {this.renderCollectionHeader(
          generalInfo.IsPolicy
            ? "POLICY PERSONAL PROPERTIES"
            : "QUOTE PERSONAL PROPERTIES"
        )}
        {personalProperties.map((personalProperty, idx) => {
          let addressDescription = this.getAddressDescription(personalProperty);

          return (
            <div key={idx}>
              {this.renderItemHeader(addressDescription)}
              {this.renderPersonalProperty(personalProperty)}
            </div>
          );
        })}
      </div>
    );
  }

  renderPersonalProperty(personalProperty) {
    return (
      <table style={{ width: "100%", fontSize: "12px" }}>
        <tbody>
          {this.renderDetail("Description", personalProperty.Description)}
          {this.renderDetail("Value", personalProperty.Value)}
        </tbody>
      </table>
    );
  }

  renderVehicle(vehicle) {
    return (
      <table style={{ width: "100%", fontSize: "12px" }}>
        <tbody>
          {this.renderDetail("Vehicle Number", vehicle.VehicleNumber)}
          {this.renderDetail("Vin", vehicle.Vin)}
          {this.renderDetail(
            "Comprehensive Deductible",
            FormatUtils.formatMoney(vehicle.CompDeductible)
          )}
          {this.renderDetail(
            "Collision Deductible",
            FormatUtils.formatMoney(vehicle.CollisionDeductible)
          )}
          {this.renderDetail(
            "Uninsured Motorist",
            FormatUtils.formatMoney(vehicle.UninsuredMotorist)
          )}
          {this.renderDetail(
            "Medical Payments",
            FormatUtils.formatMoney(vehicle.MedPay)
          )}
          {this.renderDetail(
            "Rental Reimbursement",
            FormatUtils.formatMoney(vehicle.RentalReimbursement)
          )}
          {this.renderDetail("Towing", vehicle.Towing)}
          {this.renderDetail("Glass Coverage", vehicle.GlassCoverage)}
        </tbody>
      </table>
    );
  }

  renderLocation(location, lobId) {
    let payrollInfo = location.PayrollInfo;

    if (location.PayrollInfo && location.PayrollInfo.length > 0) {
      return payrollInfo.map((item, idx) => {
        return (
          <table
            key={idx}
            style={{ width: "100%", fontSize: "12px", marginBottom: "20px" }}
          >
            <tbody>
              {this.renderDetail("WC Class Code", item.WcClassCode)}
              {this.renderDetail("Description", item.Description)}
              {this.renderDetail("Number of Employees", item.NumPersonnel)}
              {this.renderDetail(
                "Total Wages",
                FormatUtils.formatMoney(item.TotalPayroll)
              )}
            </tbody>
          </table>
        );
      });
    }

    if (~[1665].indexOf(lobId)) {
      return (
        <table style={{ width: "100%", fontSize: "12px" }}>
          <tbody>
            {!!location.BuildingCoverage &&
              location.BuildingCoverage != null &&
              location.BuildingCoverage > 0 &&
              this.renderDetail(
                "Building Coverage",
                FormatUtils.formatMoney(location.BuildingCoverage)
              )}
            {!!location.ContentsCoverage &&
              location.ContentsCoverage != null &&
              location.ContentsCoverage > 0 &&
              this.renderDetail(
                "Contents Coverage",
                FormatUtils.formatMoney(location.ContentsCoverage)
              )}
          </tbody>
        </table>
      );
    }

    if (~[200, 110, 210, 520, 1670].indexOf(lobId)) {
      return (
        <table style={{ width: "100%", fontSize: "12px" }}>
          <tbody>
            {this.renderDetail(
              "Building Coverage",
              FormatUtils.formatMoney(location.BuildingCoverage)
            )}
            {this.renderDetail(
              "Contents Coverage",
              FormatUtils.formatMoney(location.ContentsCoverage)
            )}
          </tbody>
        </table>
      );
    }

    if (lobId === 1935) {
      return (
        <table style={{ width: "100%", fontSize: "12px" }}>
          <tbody>
            {this.renderDetail("Coverage A - Dwelling", location.Dwelling)}
            {this.renderDetail(
              "Coverage B - Other Structures",
              location.OtherStructures
            )}
            {this.renderDetail(
              "Coverage C - Personal Property",
              location.PersonalProperty
            )}
            {this.renderDetail("Coverage D - Loss Of Use", location.LossOfUse)}
            {this.renderDetail(
              "Coverage E - Personal Liability",
              location.PersonalLiability
            )}
            {this.renderDetail(
              "Coverage F - Medical Payments",
              location.MedicalPayments
            )}
            {this.renderDetail(
              "All Other Perils Deductible",
              location.AllOtherPerilsDeductible
            )}
            {this.renderDetail("Wind Deductible", location.WindDeductible)}
          </tbody>
        </table>
      );
    }

    if (~[1939, 1941].indexOf(lobId)) {
      return (
        <table style={{ width: "100%", fontSize: "12px" }}>
          <tbody>
            {this.renderDetail("Coverage A - Dwelling", location.Dwelling)}
            {this.renderDetail(
              "Coverage C - Personal Property",
              location.PersonalProperty
            )}
            {this.renderDetail("Coverage D - Loss Of Use", location.LossOfUse)}
            {this.renderDetail(
              "Earthquake Deductible",
              location.EarthquakeDeductible
            )}
          </tbody>
        </table>
      );
    }

    if (~[2004, 2005].indexOf(lobId)) {
      return (
        <table style={{ width: "100%", fontSize: "12px" }}>
          <tbody>
            {this.renderDetail("Coverage A - Dwelling", location.Dwelling)}
            {this.renderDetail(
              "Coverage C - Personal Property",
              location.PersonalProperty
            )}
          </tbody>
        </table>
      );
    }

    if (lobId === 2006) {
      return (
        <table style={{ width: "100%", fontSize: "12px" }}>
          <tbody>
            {this.renderDetail("Coverage A - Dwelling", location.Dwelling)}
            {this.renderDetail(
              "Valuation",
              FormatUtils.formatMoney(location.PersonalProperty)
            )}
            {this.renderDetail(
              "Cause of Loss",
              FormatUtils.formatMoney(location.Dwelling)
            )}
            {this.renderDetail(
              "Any one building or structure",
              FormatUtils.formatMoney(location.PersonalProperty)
            )}
            {this.renderDetail(
              "All covered property at all locations",
              FormatUtils.formatMoney(location.Dwelling)
            )}
            {this.renderDetail(
              "Renovations and improvements",
              FormatUtils.formatMoney(location.PersonalProperty)
            )}
            {this.renderDetail(
              "Existing buildings or structures",
              FormatUtils.formatMoney(location.Dwelling)
            )}
          </tbody>
        </table>
      );
    }

    return null;
  }

  renderDetail(description, value) {
    return (
      <tr style={{ height: "24px" }}>
        <td style={{ color: "#636176", paddingLeft: "14px", width: "70%" }}>
          <span style={{ marginTop: "10px", marginBottom: "10px" }}>
            {description}
          </span>
        </td>
        <td className="location-detail-value">
          <span style={{ float: "right" }}>{value}</span>
        </td>
      </tr>
    );
  }

  renderCollectionHeader(description) {
    return (
      <table>
        <tbody>
          <tr>
            <td className="lob-details-policy-quote-description">
              <span>{description}</span>
            </td>
          </tr>
        </tbody>
      </table>
    );
  }

  renderItemHeader(decription) {
    return (
      <table style={{ width: "100%" }}>
        <tbody>
          <tr className="lob-details-location-header">
            <td style={{ width: "14px" }} />
            <td className="lob-details-location-header-img">
              <img alt="address" src={addressImg} className="address-img" />
            </td>
            <td className="lob-details-location-header-decription">
              <span>{decription}</span>
            </td>
          </tr>
        </tbody>
      </table>
    );
  }

  getAddressDescription(location) {
    return (
      location.Address1 +
      " " +
      location.City +
      ", " +
      location.State +
      " " +
      location.Zip
    );
  }
}

export default CollectionItems;
